import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    LocalStorageService,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { menuRoles, rolesPersonalizadas } from './core/constants/roles';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGIN = environment.URL_LOGIN;
    URL_LOGOUT = environment.URL_LOGOUT;

    menuItens: IMenu[] = [
        {
            label: '',
            roles: menuRoles.itensMenu.home.roles,
            itens: [
                {
                    label: 'Home',
                    icone: 'home',
                    link: '/home',
                    roles: menuRoles.itensMenu.home.home
                }
            ]
        },
        {
            label: 'Freelancer',
            roles: menuRoles.itensMenu.freelancer.roles,
            itens: [
                {
                    label: 'Freelancer',
                    icone: 'assignment',
                    link: '/freelancer',
                    roles: Object.values(menuRoles.itensMenu.freelancer.freelancer).flat()
                }
            ]
        },
        {
            label: 'Contrato',
            roles: menuRoles.itensMenu.contrato.roles,
            itens: [
                {
                    label: 'Contrato',
                    icone: 'description',
                    link: '/contrato',
                    roles: Object.values(menuRoles.itensMenu.contrato.contrato).flat()
                }
            ]
        },
        {
            label: 'Dados Bancários',
            roles: menuRoles.itensMenu.home.roles,
            itens: [
                {
                    label: 'Atualização de Dados Bancário',
                    icone: 'account_balance',
                    link: '/dados-bancarios',
                    roles: rolesPersonalizadas.rh.visualizar
                }
            ]
        },
        {
            label: 'Parâmetros',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Cargo',
                    icone: 'work',
                    link: '/parametros/cargo',
                    roles: menuRoles.itensMenu.parametros.cargo
                },
                {
                    label: 'Justificativa',
                    icone: 'format_align_justify',
                    link: '/parametros/justificativa',
                    roles: menuRoles.itensMenu.parametros.justificativa
                },
                {
                    label: 'Registro Profissional',
                    icone: 'badge',
                    link: '/parametros/registro-profissional',
                    roles: menuRoles.itensMenu.parametros.registroProfissional
                },
                {
                    label: 'Tipo Contratação',
                    icone: 'account_balance_wallet',
                    link: '/parametros/tipo-contratacao',
                    roles: menuRoles.itensMenu.parametros.tipoContratacao
                },
                {
                    label: 'Treinamento Obrigatório',
                    icone: 'engineering',
                    link: '/parametros/treinamento-obrigatorio',
                    roles: menuRoles.itensMenu.parametros.treinamentoObrigatorio
                },
                {
                    label: 'Signatários',
                    icone: 'person',
                    link: '/parametros/signatario',
                    roles: menuRoles.itensMenu.parametros.signatarios
                },
                {
                    label: 'Estado Civil',
                    icone: 'person_check',
                    link: '/parametros/estado-civil',
                    roles: menuRoles.itensMenu.parametros.estadoCivil
                },
                {
                    label: 'Nacionalidade',
                    icone: 'flag',
                    link: '/parametros/nacionalidade',
                    roles: menuRoles.itensMenu.parametros.nacionalidade
                }
            ]
        },
        {
            label: 'Relatório',
            roles: menuRoles.itensMenu.contrato.roles,
            itens: [
                {
                    label: 'Contratos',
                    icone: 'description',
                    link: '/relatorio',
                    roles: Object.values(menuRoles.itensMenu.contrato.contrato).flat()
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoesService: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService
    ) {
        _permissoesService.initPermissoes();
    }

    ngOnInit() {}

    async logout(event: boolean) {
        if (event) {
            try {
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete('access_token', '/', domain);
        this._cookie.delete('refreshToken', '/', domain);
    }
}
